import { Stack } from '@my/ui'
import { UniversityEmailForm, UniversityEmailFormValues } from 'app/features/onboarding/components'
import { useUpdateUniversityEmail } from 'app/features/onboarding/commands'
import { useState } from 'react'
import { useRouter } from 'solito/router'

export const VerifyDialogPage = () => {
  const [emailError, setError] = useState<string | undefined>(undefined)

  const { push } = useRouter()

  const [updateUniversityEmail, { loading }] = useUpdateUniversityEmail()

  const handleUpdateUniversityEmail = async (data: UniversityEmailFormValues) => {
    try {
      await updateUniversityEmail({
        variables: {
          universityEmail: data.email,
        },
        onCompleted: (data) => {
          if (!data?.updateUniversityEmail?.success) {
            setError(data?.updateUniversityEmail?.message)
            return
          }
          push('/onboarding/student/university-email-submitted')
        },
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Stack width="100%" px="$6">
      <UniversityEmailForm
        onSubmit={handleUpdateUniversityEmail}
        loading={loading}
        error={emailError}
      />
    </Stack>
  )
}
